import { Component, Input, EventEmitter, Output } from '@angular/core';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-error-toaster',
  templateUrl: './error-toaster.component.html',
  styleUrl: './error-toaster.component.scss'
})
export class ErrorToasterComponent {
  @Input() title: string = '';
  @Output() closeToaster: EventEmitter<any> = new EventEmitter<any>()
  delayTime: number = 3000;  //3 seconds
  showToaster: boolean = true;
  faCircleQuestion = faCircleQuestion;

  constructor() {
    this.startClosingToaster()
  }

  startClosingToaster() {
    setTimeout(() => {
      this.showToaster = false;
      this.closeToaster.emit(false);
    }, this.delayTime)
  }

  closeToast() {
    this.showToaster = false;
    this.closeToaster.emit(false);
  }
}
